import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Circle as Icon } from '@alfalab/core-components-icon-view/circle';

import type { TCircle, IDepsCircle } from './models';
import { IconView as Component } from './views/circle-and-super-ellipse';

export const IconViewCircle = createWidget<IDepsCircle, TCircle>(
    { Icon },
    { priorityStyler: true }
)(Component);
